



























































import { Vue, Component, Prop } from 'vue-property-decorator';

import Picture from '@/components/atoms/Picture/Picture.vue';
import CloseIcon from '@/components/icons/Close.vue';

import BusinessItem from './BusinessItem.vue';
import BusinessMenuItem from './BusinessMenuItem.vue';
import BusinessMenuList from './BusinessMenuList.vue';

import ManagerService from '@/api/ManagerService';
import BusinessService from '@/api/BusinessService';

import eventBus from '@/utils/eventBus';
import { isRootUser } from '@/utils/auth';
import { insideProviderIframe } from '@/utils/providerIframe';
import { getGroupById } from '@/router';
import flagKeys from '@/constants/flagKeys';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import { removeExternalOauthSession } from '@/router/router-utils';
import { FilledButton } from '@/components/molecules';
import { Route } from '@/router/route.model';
import { getSignUpUrl } from '@/views/Onboarding/helpers';
import LinkIcon from '@/components/icons/ExternalLinkV2.vue';
import segmentIo from '@/utils/segment.io';
import {
  getNeedsOnboardingCall,
  getShowOnboardingCallBanner
} from '@/utils/onboardingCall';

@Component({
  components: {
    Picture,
    BusinessItem,
    BusinessMenuItem,
    CloseIcon,
    BusinessMenuList,
    FilledButton,
    LinkIcon
  }
})
export default class BusinessMenuContent extends Vue {
  @Prop(Boolean) readonly viewOnly: boolean | undefined;
  @Prop() notification?: any;
  loading: boolean = false;

  managerService: ManagerService = new ManagerService();
  businessService: BusinessService = new BusinessService();

  businesses = [];

  get tPrefix() {
    return 'menus.sidebar.businessMenuDrop';
  }

  get activeBusiness() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  get isInsideProviderIframe() {
    return insideProviderIframe();
  }

  get showMerchantLP() {
    return (
      this.activeBusiness.businessLocations &&
      this.activeBusiness.businessLocations.length > 0 &&
      !getNeedsOnboardingCall()
    );
  }

  get showFeedback() {
    return (
      this.currentProvider &&
      this.getFlags.includes(flagKeys.feedbackPlatform) &&
      this.activeBusiness.showPlatformFeedbackCta
    );
  }

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  get navbarMenu() {
    const group = getGroupById('business-menu');
    if (!group) {
      return [];
    }

    return group.getVisibleRoutes();
  }

  get showListOfBusiness() {
    return !isRootUser() && !insideProviderIframe();
  }

  get getFlags() {
    return this.$store.getters['flags/getFlags'];
  }

  async getBusinesses() {
    const response = await this.managerService.getBusinessList();
    if (response && response.status === 200) {
      this.businesses = response.data;
    }
  }

  clickRoute(e: Event, route: Route) {
    e.preventDefault();

    if (this.$mobileCheck()) {
      eventBus.$emit('toggleLeftBarMobile', false);
    }
    this.$router.push(route.path);
  }

  openMerchantLP() {
    segmentIo.track('Clicked My Landing Page Link');
    window.open(this.activeBusiness.branchLinks.landingPageLink, '_blank');
  }

  gotoSignup() {
    if (this.viewOnly) {
      return;
    }

    if (this.$mobileCheck()) {
      this.$emit('toggleLeftBarMobile', false);
    }

    this.$store.dispatch('businessOnboarding/RESET_BUSINESS_ONBOARDING');
    removeExternalOauthSession();

    this.$router.push(`${getSignUpUrl()}?new-business=true`);
  }

  openFeedback() {
    if (this.$mobileCheck()) {
      this.$emit('toggleLeftBarMobile', false);
    }
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'feedbackModal',
        hideCancelButton: false,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      })
    );
  }

  created() {
    if (this.showListOfBusiness) {
      this.getBusinesses();
      eventBus.$on('reloadBusinessMenuDropdown', this.getBusinesses);
    }
  }

  beforeDestroy() {
    if (this.showListOfBusiness) {
      eventBus.$off('reloadBusinessMenuDropdown', this.getBusinesses);
    }
  }
}
